<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <a v-if="checkPermission('AddTarifAnnuel')"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#AddTarifAnnuelModal"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un tarif
        </a>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
       <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un tarif"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                MODELE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                CATEGORIE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                COUT
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                TYPE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Frais de cle
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nombre de clef
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Caution
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tarif, index) in tarifAnnuels" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ tarif.modeleBoite.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tarif.categorie.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(tarif.cout) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tarif.type }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tarif.fraisCle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tarif.nombreCle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ tarif.caution }}
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditTarifAnnuel')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="editTarifAnnuel(tarif.id)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteTarifAnnuel')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(tarif.id,tarifAnnuels,'tarifAnnuels','un tarif')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
       <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddTarifAnnuelModal :item="selectedItem"  @close="recharger" @openmodal="show_Modal"/>
</template>
<script lang="ts">
import { ref,defineComponent,onMounted, watch } from "vue";
import AddTarifAnnuelModal from "./AddTarifAnnuelModal.vue";
import { showModal, suppression, separateur, error  } from "@/utils/utils";
import { TarifAnnuel } from "@/models/TarifAnnuel";
import ApiService from "@/services/ApiService";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";

export default defineComponent({
    name: "ListeTarifAnnuel",
    components: {
      AddTarifAnnuelModal,
      PaginationComponent
      
  },
  setup: () => {
    const tarifAnnuels = ref<Array<TarifAnnuel>>([]);
    const tarifAnnuel = ref<TarifAnnuel>();
    const selectedItem = ref(0);
    const addTarifAnnuelsModalRef = ref<null | HTMLElement>(null);

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllTarifAnnuel(page_, limit_, searchTerm.value);
      } catch (error) {
        //
        
      }
    };
    function rechercher(){
      watch((searchTerm), (newValue) => {
        if (newValue) { page.value = 1;  }
      })
      getAllTarifAnnuel(page.value, limit.value, searchTerm.value );
    }
    // END PAGINATE

    function getAllTarifAnnuel(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/tarifAnnuels?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      .then(({ data }) => {
        tarifAnnuels.value = data.data.data;
         totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 
    const recharger = () => {
      getAllTarifAnnuel();
    };
    const show_Modal = (el) => {
      
      showModal(el);
      selectedItem.value = 0;
    };

    const editTarifAnnuel = (id: number) => {
      selectedItem.value = id;
    };

    onMounted(() => {
      getAllTarifAnnuel();
    });

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

const checkPermission = (name) => {
  return privileges.value.includes(name);
}

    return { tarifAnnuels,checkPermission,
    suppression,
    editTarifAnnuel,
    AddTarifAnnuelModal,
    selectedItem ,
    recharger,
    show_Modal,
    page, 
    totalPages,
    limit,
    separateur,
    totalElements,
    handlePaginate,
    searchTerm,
    rechercher
     };
  },
});
</script>